import type { DownloadState, SSEPhase } from '../types'

interface StatusMessageProps {
  state: DownloadState
  phase: SSEPhase | null
  progress: number
  errorMessage: string | null
  canShare: boolean
}

function Spinner() {
  return (
    <span className="inline-block w-4 h-4 border-2 border-transparent border-t-current rounded-full animate-spin-slow mr-2 align-middle" />
  )
}

export function StatusMessage({ state, phase, progress, errorMessage, canShare }: StatusMessageProps) {
  if (state === 'idle' || state === 'preparing') return null

  const getContent = () => {
    if (state === 'fetching' || phase === 'fetching') {
      return (
        <>
          <Spinner />
          Fetching video data...
        </>
      )
    }

    if (state === 'downloading' || phase === 'downloading') {
      return (
        <>
          <Spinner />
          Downloading video... {progress > 0 ? `${progress}%` : ''}
        </>
      )
    }

    if (state === 'complete') {
      return canShare
        ? 'Download complete!'
        : 'Tap "Save to Files" then save to Photos from there'
    }

    if (state === 'error') {
      return errorMessage || 'An error occurred'
    }

    return null
  }

  const getClassName = () => {
    if (state === 'fetching' || state === 'downloading') {
      return 'bg-twitter-blue/20 text-twitter-blue'
    }
    if (state === 'complete') {
      return 'bg-success-green/20 text-success-green'
    }
    if (state === 'error') {
      return 'bg-error-red/20 text-error-red'
    }
    return ''
  }

  const content = getContent()
  if (!content) return null

  return (
    <div className={`mt-5 px-4 py-4 rounded-xl text-center ${getClassName()}`}>
      {content}
    </div>
  )
}
